var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilitaryTech(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3671_17681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3671_17681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38477 2.57703H16.6158V9.65778C16.6158 10.0154 16.5196 10.3474 16.3273 10.6538C16.1349 10.9603 15.8759 11.2116 15.5503 11.4078L12.1925 13.4308L12.931 15.8078H15.808L13.4388 17.4693L14.3695 20.3848L12.0003 18.573L9.63102 20.3848L10.5618 17.4693L8.19252 15.8078H11.0695L11.808 13.4308L8.41177 11.4463C8.0861 11.2629 7.83352 11.0116 7.65402 10.6923C7.47452 10.3731 7.38477 10.0283 7.38477 9.65778V2.57703ZM8.38477 3.57703V9.65778C8.38477 9.85011 8.43285 10.0264 8.52902 10.1865C8.62518 10.3469 8.7566 10.4783 8.92327 10.5808L11.5003 12.0885V3.57703H8.38477ZM15.6158 3.57703H12.5003V12.0885L15.0773 10.5808C15.2439 10.4783 15.3753 10.3469 15.4715 10.1865C15.5677 10.0264 15.6158 9.85011 15.6158 9.65778V3.57703Z",
    fill: "#FCFCFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitaryTech);
export default __webpack_public_path__ + "static/media/military_tech.f5ae5aa97bc0f9d46dad4c0d656cdc7b.svg";
export { ForwardRef as ReactComponent };